import styled from 'styled-components'

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  min-height: 42px;
`

export const ArrowPopper = styled.div`
  position: absolute;
  width: 10px;
  height: 10px;
  background-color: ${({ theme }) => theme?.colors?.white};
  transform: rotate(45deg);
  z-index: 0;
  top: -5px;
  box-shadow: -1px -1px 1px rgba(0, 0, 0, 0.1);

  &[data-popper-placement^='bottom'] {
    top: -5px;
  }

  &[data-popper-placement^='top'] {
    bottom: -5px;
  }

  &[data-popper-placement^='left'] {
    right: -5px;
  }

  &[data-popper-placement^='right'] {
    left: -5px;
  }
`
